import { combine } from '../trx/operators/combine.js';
import { map } from '../trx/operators/map.js';
import { withDefault } from '../trx/operators/withDefault.js';
import { log } from './Container.js';
/**
 * Creates a combine observable that maps onto the given expression
 * @param expression the expression to use. Can contain placeholders like #{varName} or #{varName}{defaultValue}
 * @param createObservable a callback that creates the observables for a placeholder
 * @returns a observable for the given expression
 * @todo use a real parser/lexer/interpreter instead of the unsafe Function constructor, to allow for untrusted/partially trusted input (and to validate expressions upfront instead of only upon evaluation)
 */
export function parseExpression(expression, createObservable) {
    const variables = [];
    expression = expression.replace(/#\{([^{]+?)\}(?:\{([^{]+?)\})?/g, (_match, varName, defaultValue) => {
        let observable = createObservable(varName);
        if (defaultValue) {
            defaultValue = new Function(`return (${defaultValue})`)();
            observable = withDefault(observable, defaultValue);
        }
        variables.push(observable);
        return `(variables[${variables.length - 1}])`;
    });
    log.debug('Creating expression', expression, 'for variables', variables);
    return map(combine(...variables), new Function('variables', `return (${expression})`));
}
